// routes
import Router from './routes';
// theme
import ThemeConfig from './theme';
// hooks
import useAuth from './hooks/useAuth';

// socket
// import {socket} from './socket';
// components
import Settings from './components/settings';
import RtlLayout from './components/RtlLayout';
import ScrollToTop from './components/ScrollToTop';
import LoadingScreen from './components/LoadingScreen';
import NProgressBar from './components/NProgressBar';
import GoogleAnalytics from './components/GoogleAnalytics';
import InstallPromptManager from './components/InstallPromptManager';
import NotistackProvider from './components/NotistackProvider';
import ThemePrimaryColor from './components/ThemePrimaryColor';
import ThemeLocalization from './components/ThemeLocalization';
import LoginNoticeModal from './components/LoginNoticeModal';
import EnvironmentBadge from './components/EnvironmentBadge';
/// updated yellow
// ----------------------------------------------------------------------
export default function App() {
  const { isInitialized, user } = useAuth();
  // console.log('is initialize: ',isInitialized);
  // console.log('user: ',user);
  return (
    <ThemeConfig>
      <ThemePrimaryColor>
        <ThemeLocalization>
          <RtlLayout>
            <NotistackProvider>
              <NProgressBar />
              {/* Covers pages with no navbar to put a chip in — login most of
                  all, since that is when real credentials get typed. Renders
                  nothing in production, and stands down under /dashboard where
                  the navbar chip takes over. */}
              <EnvironmentBadge />
              <LoginNoticeModal />
              <Settings />
              <ScrollToTop />
              <GoogleAnalytics />
              <InstallPromptManager />
              {isInitialized ? <Router /> : <LoadingScreen />}
            </NotistackProvider>
          </RtlLayout>
        </ThemeLocalization>
      </ThemePrimaryColor>
    </ThemeConfig>
  );
}
